import React from 'react';

const FraudHQPage = () => {
  return (
    <div className="h-full bg-white overflow-y-auto">
      <div className="bg-white">
        {/* Title Section */}
        <div className="px-6 py-6">
          <h1 className="text-4xl font-bold text-black">+50 Fraud HQ</h1>
        </div>

        {/* Hero Section */}
        <div className="flex justify-center py-4">
          <div className="grid grid-cols-4 gap-4 h-48 w-[90%]">
            {/* Hero Image */}
            <div 
              className="col-span-1 bg-cover bg-center bg-no-repeat overflow-hidden"
              style={{ 
                backgroundImage: `url(/mockup_images/marketing-remodel/Dashboard/LearnMore/LearnMore-50Fraud.jpeg)`,
              }}
            />
            
            {/* Stat Boxes */}
            <div className="text-white p-4 flex flex-col justify-center items-center text-center" style={{ backgroundColor: '#DA7842' }}>
              <div className="text-2xl font-bold mb-2">4.2 Million</div>
              <div className="text-sm">Victims</div>
            </div>
            
            <div className="text-white p-4 flex flex-col justify-center items-center text-center" style={{ backgroundColor: '#EA3323' }}>
              <div className="text-2xl font-bold mb-2">$50.5 Billion</div>
              <div className="text-sm">Stolen</div>
            </div>
            
            <div className="text-white p-4 flex flex-col justify-center items-center text-center" style={{ backgroundColor: '#77391A' }}>
              <div className="text-2xl font-bold mb-2">836,000</div>
              <div className="text-sm">Average victims</div>
            </div>
          </div>
        </div>
        
        {/* Sources Section */}
        <div className="text-center py-4">
          <p className="text-gray-600 text-sm">Sources | FBI \ IC3 2024 IC3 ANNUAL REPORT</p>
        </div>
        
        {/* Content Section */}
        <div className="px-6 py-8">
          <div className="max-w-6xl mx-auto">
            
            {/* What to Know */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">What to Know</h2>
              <p className="text-black mb-4">
                Each year, elderly Americans are victimized financial frauds - romance, lottery, and sweepstakes scams. Seniors are often targeted because they tend to be trusting and polite. They also usually have financial savings, own a home, and have good credit—all of which make them attractive to scammers.
              </p>
              <p className="text-black">
                Additionally, seniors may be less inclined to report fraud because they don't know how, or they may be too ashamed at having been scammed. They might also be concerned that their relatives will lose confidence in their abilities to manage their own financial affairs. And when an elderly victim does report a crime, they may be unable to supply detailed information to investigators.
              </p>
            </div>

            {/* Common +50 Frauds */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Common +50 Frauds</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="border-2 border-blue-400 p-6">
                  <h3 className="text-lg font-bold text-blue-600 mb-3">Cryptocurrency</h3>
                  <p className="text-black text-sm">
                    Deceptive practice that induces investors to make purchases on the basis of false information. These scams usually offer the victims large returns with minimal risk. Variations of this scam include retirement schemes, Ponzi schemes and pyramid schemes.
                  </p>
                </div>

                <div className="border-2 border-pink-400 p-6">
                  <h3 className="text-lg font-bold text-pink-600 mb-3">Romance scam</h3>
                  <p className="text-black text-sm">
                    Criminals pose as interested romantic partners on social media or dating websites to capitalize on their elderly victims' desire to find companions.
                  </p>
                </div>

                <div className="border-2 border-green-400 p-6">
                  <h3 className="text-lg font-bold text-green-600 mb-3">Tech support scam</h3>
                  <p className="text-black text-sm">
                    Criminals pose as technology support representatives and offer to fix non-existent computer issues. The scammers gain remote access to victims' devices and sensitive information.
                  </p>
                </div>

                <div className="border-2 border-purple-400 p-6">
                  <h3 className="text-lg font-bold text-purple-600 mb-3">Grandparent scam</h3>
                  <p className="text-black text-sm">
                    A type of confidence scam where criminals pose as a relative—usually a child or grandchild—claiming to be in immediate financial need.
                  </p>
                </div>

                <div className="border-2 border-red-400 p-6">
                  <h3 className="text-lg font-bold text-red-600 mb-3">Government impersonation scam</h3>
                  <p className="text-black text-sm">
                    Criminals pose as government employees and threaten to arrest or prosecute victims unless they agree to provide funds or other payments.
                  </p>
                </div>

                <div className="border-2 border-yellow-400 p-6">
                  <h3 className="text-lg font-bold text-yellow-600 mb-3">Sweepstakes/charity/lottery scam</h3>
                  <p className="text-black text-sm">
                    Criminals claim to work for legitimate charitable organizations to gain victims' trust. Or they claim their targets have won a foreign lottery or sweepstake, which they can collect for a "fee."
                  </p>
                </div>

                <div className="border-2 border-indigo-400 p-6">
                  <h3 className="text-lg font-bold text-indigo-600 mb-3">Home repair scam</h3>
                  <p className="text-black text-sm">
                    Criminals appear in person and charge homeowners in advance for home improvement services that they never provide.
                  </p>
                </div>

                <div className="border-2 border-orange-400 p-6">
                  <h3 className="text-lg font-bold text-orange-600 mb-3">TV/radio scam</h3>
                  <p className="text-black text-sm">
                    Criminals target potential victims using illegitimate advertisements about legitimate services, such as reverse mortgages or credit repair.
                  </p>
                </div>

                <div className="border-2 border-gray-400 p-6 md:col-span-2">
                  <h3 className="text-lg font-bold text-gray-600 mb-3">Family/caregiver scam</h3>
                  <p className="text-black text-sm">
                    Relatives or acquaintances of the elderly victims take advantage of them or otherwise get their money.
                  </p>
                </div>
              </div>
            </div>

            {/* Protect Yourself */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-black mb-4">Protect Yourself</h2>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">1</div>
                  <p className="text-black">Recognize scam attempts and end all communication with the perpetrator. Create a shared verbal family password or phrase that only you and your loved ones know.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">2</div>
                  <p className="text-black">Search online for the contact information (name, email, phone number, addresses) and the proposed offer. Other people have likely posted information online about individuals and businesses trying to run scams.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">3</div>
                  <p className="text-black">Resist the pressure to act quickly. Scammers create a sense of urgency to produce fear and lure victims into immediate action.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">4</div>
                  <p className="text-black">Call the police immediately if you feel there is a danger to yourself or a loved one.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">5</div>
                  <p className="text-black">Be cautious of unsolicited phone calls, mailings, and door-to-door services offers.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">6</div>
                  <p className="text-black">Never give or send any personally identifiable information, money, gold or other precious metals, jewelry, gift cards, checks, or wire information to unverified people or businesses.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">7</div>
                  <p className="text-black">Make sure all computer anti-virus and security software and malware protections are up to date. Use reputable anti-virus software and firewalls.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">8</div>
                  <p className="text-black">Disconnect from the internet and shut down your device if you see a pop-up message or locked screen. Pop-ups are regularly used by perpetrators to spread malicious software. Enable pop-up blockers to avoid accidentally clicking on a pop-up.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">9</div>
                  <p className="text-black">Be careful what you download. Never open an email attachment from someone you don't know and be wary of email attachments forwarded to you.</p>
                </div>

                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold mr-4 mt-1 flex-shrink-0">10</div>
                  <p className="text-black">Take precautions to protect your identity if a criminal gains access to your device or account. Immediately contact your financial institutions to place protections on your accounts and monitor your accounts and personal information for suspicious activity.</p>
                </div>
              </div>
            </div>

            {/* No / SCAM */}
            <div className="bg-blue-50 border border-blue-200 p-6">
              <h2 className="text-2xl font-bold text-blue-800 mb-4">No / SCAM</h2>
              <p className="text-blue-700">
                This scammer aware risk intelligence agent helps keep you out of trouble – effortlessly. 360 AI transforms how you interact with the internet. This next-level technology uses Intelligent Pattern Overwatch Detection with defined safety boundaries that guard against the inadvertent clicking of embedded high-risk scam hyperlinks.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default FraudHQPage;